import { Cell } from '@table-library/react-table-library/table';
import Action from '../../actions';
import { colors } from '../../../../../lib/colors';
import DomainImage from '../../../../../components/DomainImage';
import { AI_TOOLS } from '../../../configs';
import { showPlatform } from '../../../PromptManager/keys';
import { getMainDomain } from '../../../../../helpers/normalizeDomain';

export const COLUMNS = (t, project, updateProject, data) => [
    {
        label: t('ai_tracking.keyword_detail.domains.columns.domain'),
        key: 'base_domain',
        data: 'base_domain',
        Component: Cell,
        cellSize: 'minmax(200px, 2fr)',
        sortType: 'string',
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item.base_domain;
            return (
                <div>
                    <strong className="wrap-text d-flex align-items-center">
                        {getColor(item, data)}
                        <DomainImage domain_name={item.base_domain} className="domain_img" />
                        <span>{item.base_domain}</span>
                    </strong>
                </div>
            );
        },
    },
    {
        label: t('ai_tracking.keyword_detail.domains.columns.platforms'),
        key: 'platforms',
        data: 'platforms',
        Component: Cell,
        sortType: 'string',
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            const platforms = data?.split(',') || [];
            return (
                <div className="d-flex flex-wrap gap-4">
                    {Object.keys(AI_TOOLS).map((state) => (
                        <div
                            key={state}
                            title={AI_TOOLS[state]}
                            className={`ai-tracking-platform-2 no-clickable ${
                                platforms?.includes(state) ? '' : 'disabled'
                            }`}
                        >
                            {showPlatform(state)}
                        </div>
                    ))}
                </div>
            );
        },
    },
    {
        label: t('ai_tracking.keyword_detail.domains.columns.rankingShare'),
        key: 'citatioShare',
        data: 'citatioShare',
        Component: Cell,
        sortType: 'number',
        renderCell: ({ data }) => {
            return `${data?.toFixed(2)} %`;
        },
    },
    {
        label: t('ai_tracking.keyword_detail.domains.columns.avgPosition'),
        key: 'avgPosition',
        data: 'avgPosition',
        Component: Cell,

        renderCell: ({ data, item }) => {
            return data.toFixed(2);
        },
        sortType: 'number',
    },
    {
        label: t('ai_tracking.keyword_detail.domains.columns.uniqueUrls'),
        key: 'domainUniqueUrls',
        data: 'domainUniqueUrls',
        sortType: 'number',
        Component: Cell,
    },
    {
        label: '',
        key: 'actions',
        data: 'actions',
        Component: Cell,
        renderCell: ({ item }) => (
            <Action
                domain={item.base_domain}
                brand={getMainDomain(item.base_domain)}
                project={project}
                updateProject={updateProject}
            />
        ),
    },
];

function getColor(item, data) {
    const sortedData = data?.sort((a, b) => b.citatioShare - a.citatioShare) ?? [];
    const index = sortedData.findIndex((state) => state.base_domain === item.base_domain);
    const color = index >= 20 ? colors[20] : colors[index];

    return <div className="color-box mr-16" style={{ backgroundColor: color }}></div>;
}
